"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPumpMcFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 18.38V7H20V4h-2v3h-3v13.64l15-2.26zM9.55 7a4.65 4.65 0 00-3.71 1.3C4.64 9.49 4 11.63 4 14.5c0 2 .32 4.72 1.84 6.21A4.6 4.6 0 009.55 22H13V7zM23 21.46l-8 1.2V24h-4v2h15v-2h-3v-2.54z" })));
}
exports.default = SvgPumpMcFilled;
//# sourceMappingURL=PumpMcFilled.js.map